function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M399.75,413.943c-4.695-0.277-8.673,3.331-8.928,8.008l-3.97,73.09H125.147l-15.65-288.147  c-0.253-4.675-4.236-8.271-8.928-8.008c-4.677,0.254-8.262,4.25-8.008,8.928l16.086,296.167c0.244,4.498,3.963,8.02,8.468,8.02  h277.769c4.505,0,8.223-3.522,8.468-8.02l4.405-81.11C408.012,418.193,404.426,414.197,399.75,413.943z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M412.008,45.387h-85.161V27.485C326.848,12.329,314.519,0,299.364,0h-86.728c-15.155,0-27.485,12.329-27.485,27.485v17.902  H99.99c-27.627,0-50.103,22.476-50.103,50.103v25.589c0,4.683,3.797,8.48,8.48,8.48h29.944l2.407,44.335  c0.245,4.52,3.987,8.021,8.46,8.02c0.155,0,0.311-0.003,0.467-0.012c4.677-0.254,8.262-4.25,8.008-8.928l-2.357-43.415h214.118  c4.683,0,8.48-3.797,8.48-8.48s-3.797-8.48-8.48-8.48H66.849v-17.11c0-18.275,14.867-33.143,33.143-33.143h93.641h124.736h93.641  c18.275,0,33.143,14.867,33.143,33.143v17.108h-91.815c-4.683,0-8.48,3.797-8.48,8.48c0,4.683,3.797,8.48,8.48,8.48h53.366  l-14.037,258.472c-0.254,4.676,3.331,8.673,8.008,8.928c0.157,0.009,0.312,0.012,0.468,0.012c4.473,0,8.214-3.501,8.46-8.02  l14.087-259.393h29.944c4.683,0,8.48-3.797,8.48-8.48V95.489C462.111,67.863,439.636,45.387,412.008,45.387z M202.112,45.387V27.485  c0-5.803,4.721-10.524,10.524-10.524h86.728c5.803,0,10.524,4.721,10.524,10.524v17.902H202.112z"
});

var SvgDeleteGallery = function SvgDeleteGallery(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383"
    },
    d: "M299.364,8.48h-86.728c-10.496,0-19.005,8.508-19.005,19.005v59.672h124.736V27.485   C318.367,16.989,309.859,8.48,299.364,8.48z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#454545"
    },
    points: "394.884,503.52 117.116,503.52 94.502,87.157 417.498,87.157  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    points: "417.498,87.157 94.501,87.157 98.186,154.998 413.813,154.998 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#454545"
    },
    d: "M412.008,53.867H99.99c-22.987,0-41.623,18.635-41.623,41.623v25.589H453.63v-25.59   C453.631,72.502,434.996,53.867,412.008,53.867z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383"
    },
    d: "M256,439.961c-12.49,0-22.614-10.124-22.614-22.614V207.25c0-12.49,10.124-22.614,22.614-22.614   c12.49,0,22.614,10.124,22.614,22.614v210.097C278.614,429.837,268.49,439.961,256,439.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383"
    },
    d: "M176.841,439.961c-12.209,0-22.263-9.727-22.594-22.005l-5.653-210.096   c-0.336-12.485,9.512-22.877,21.997-23.214c12.504-0.345,22.877,9.512,23.214,21.997l5.653,210.096   c0.336,12.485-9.512,22.877-21.997,23.214C177.253,439.958,177.045,439.961,176.841,439.961z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#838383"
    },
    d: "M335.158,439.961c-0.206,0-0.412-0.002-0.62-0.008c-12.485-0.337-22.333-10.729-21.997-23.214   l5.653-210.096c0.331-12.277,10.388-22.005,22.594-22.005c0.206,0,0.412,0.002,0.62,0.008   c12.485,0.337,22.333,10.729,21.997,23.214l-5.653,210.096C357.422,430.232,347.366,439.961,335.158,439.961z"
  })), _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeleteGallery, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delete-gallery.e2d4b226.svg";
export { ForwardRef as ReactComponent };